import { render } from "./images_modal.vue?vue&type=template&id=0c21f130&scoped=true"
import script from "./images_modal.vue?vue&type=script&lang=js"
export * from "./images_modal.vue?vue&type=script&lang=js"

import "./images_modal.vue?vue&type=style&index=0&id=0c21f130&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c21f130"]])

export default __exports__